import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getDefaultLicenseLimits} from 'src/openapi/admin/apis/LicenseLimitsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {LicenseType} from 'src/openapi/admin/models/LicenseType';

type Props = {
    licenseType: LicenseType,
};

export const useDefaultLicenseLimits = ({licenseType}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getDefaultLicenseLimits({licenseType}, {signal}),
    ), [licenseType, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
